
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as icons_45page1W1P71Yc9rsqXOCbJQpZhFRHK3c6RWb2TaOsaSxaX6oMeta } from "/app/node_modules/@nuxtjs/svg-sprite/dist/runtime/components/icons-page.vue?macro=true";
import { default as _91id_93Eaejf4V0mF0jNTJGur_458t8I9CE24JYR_45Ucp4mIh_45wwEMeta } from "/app/pages/index/[id].vue?macro=true";
import { default as index74tUkbx7x8b6PFMdA9H6UrdP6t7QDUx2J_2QpXc6e3YMeta } from "/app/pages/index/index.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as memoryiG_45F5Pe1npyxS6bpx5w1x1qBagjsvvqP3G_P9z3mVIkMeta } from "/app/pages/memory.vue?macro=true";
import { default as template_45managerWQ5_45pEqUsrJLg4nWIOztijFf2UsER9hgXileff6MTZQMeta } from "/app/pages/template-manager.vue?macro=true";
import { default as _91id_93HEpn3swrC_ZxfN0rEGfiojyxwSPO8k_45GcCxlMPFYilgMeta } from "/app/pages/external/[slug]/[id].vue?macro=true";
import { default as create_45sessionTYvA2GQK_A5wO091aRR6L2QRrU3IswJbTXJEr3Z3EloMeta } from "/app/pages/external/create-session.vue?macro=true";
export default [
  {
    name: "icons-page",
    path: "/_icons",
    meta: {"layout":"svg-sprite"},
    component: () => import("/app/node_modules/@nuxtjs/svg-sprite/dist/runtime/components/icons-page.vue")
  },
  {
    name: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta?.name,
    path: "/",
    component: () => import("/app/pages/index.vue"),
    children: [
  {
    name: "index-id",
    path: ":id()",
    meta: _91id_93Eaejf4V0mF0jNTJGur_458t8I9CE24JYR_45Ucp4mIh_45wwEMeta || {},
    component: () => import("/app/pages/index/[id].vue")
  },
  {
    name: "index",
    path: "",
    meta: index74tUkbx7x8b6PFMdA9H6UrdP6t7QDUx2J_2QpXc6e3YMeta || {},
    component: () => import("/app/pages/index/index.vue")
  }
]
  },
  {
    name: "login",
    path: "/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "memory",
    path: "/memory",
    meta: memoryiG_45F5Pe1npyxS6bpx5w1x1qBagjsvvqP3G_P9z3mVIkMeta || {},
    component: () => import("/app/pages/memory.vue")
  },
  {
    name: "template-manager",
    path: "/template-manager",
    meta: template_45managerWQ5_45pEqUsrJLg4nWIOztijFf2UsER9hgXileff6MTZQMeta || {},
    component: () => import("/app/pages/template-manager.vue")
  },
  {
    name: "external-slug-id",
    path: "/external/:slug()/:id()",
    meta: _91id_93HEpn3swrC_ZxfN0rEGfiojyxwSPO8k_45GcCxlMPFYilgMeta || {},
    component: () => import("/app/pages/external/[slug]/[id].vue")
  },
  {
    name: "external-create-session",
    path: "/external/create-session",
    meta: create_45sessionTYvA2GQK_A5wO091aRR6L2QRrU3IswJbTXJEr3Z3EloMeta || {},
    component: () => import("/app/pages/external/create-session.vue")
  }
]